import React, { Children, isValidElement } from "react";
import { RadioGroup as ChakraRadioGroup, Stack, } from "@chakra-ui/react";
export function RadioGroup({ isDisabled, children, orientation: defaultOrientation = "horizontal", ...props }) {
    let hasDescriptions = false;
    for (const child of Children.toArray(children)) {
        if (isValidElement(child) && child.props.description) {
            hasDescriptions = true;
            break;
        }
    }
    let orientation = defaultOrientation === "horizontal" ? "row" : "column";
    // Switch orientation to vertical if there are more than 3 radios or at least one has a description
    if (hasDescriptions || Children.count(children) > 3) {
        orientation = "column";
    }
    return (React.createElement(ChakraRadioGroup, { isDisabled: isDisabled, ...props },
        React.createElement(Stack, { align: "start", direction: orientation, spacing: orientation === "column" && !hasDescriptions ? 2 : 4 }, children)));
}
